var map = {
	"./app_strings.json": 33572,
	"./client/account_client.json": 18632,
	"./client/common_client.json": 90766,
	"./client/consultation_client.json": 24943,
	"./client/eyes.json": 6417,
	"./client/nav_client.json": 43748,
	"./client/patient_client.json": 89586,
	"./client/pdf.json": 91586,
	"./client/shop_client.json": 23148,
	"./client/stats_client.json": 11293,
	"./client/validations.json": 33946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49741;